// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "._29LPfCVm2_rdNVj8MCamXm {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n}\n", "",{"version":3,"sources":["QUnit.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC","file":"QUnit.css","sourcesContent":[".QUnit {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n}\n"]}]);
// Exports
exports.locals = {
	"QUnit": "_29LPfCVm2_rdNVj8MCamXm"
};
module.exports = exports;
